<template>
    <div class="content-body customers-wrapper customer-list">
        <b-row>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <i class="icon-calendar"></i>
                    </b-input-group>
                    <datepicker
                        :config="daterangeConfig"
                        :v-model="filter.date">
                    </datepicker>
                </b-input-group>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                        <b-form-input @keyup.native="search(true)" placeholder="Search" v-model="filter.keyword"></b-form-input>
                        <b-dropdown text="Advanced" variant="primary" slot="append">
                            <b-dropdown-item @click="searchOption(field.key)" v-for="(field, index) in searchFields" :key="index">
                                {{ field.label }}
                                <i v-if="filter.field === field.key" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                </i>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-input-group>
                </div>
            </b-col>
            <b-col md="6">
                <b-button variant="primary btn-table-export">Export</b-button>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table
                    :fields="fields"
                    :items="isSearchType ? [] : transactionHistory"
                    :current-page="transactionHistoryPagination.page"
                    ref="transactionHistoryList"
                    responsive
                    show-empty
                    :empty-text="(loading) ? 'Loading data' : emptyText">
                    <template slot="created_at" slot-scope="data">
                        {{ formatDate(data.value) }}
                    </template>
                    <template slot="type" slot-scope="data">
                        <template v-if="data.value == 'topup'">
                            Top-up
                        </template>
                        <template v-else>
                            <span class="text-capitalize">{{ data.value.replace('_', ' ') }}</span>
                        </template>
                    </template>
                    <template slot="debit" slot-scope="data">
                        <template v-if="data.value">
                            {{ data.value }}
                        </template>
                        <template v-else>
                            {{ data.item.credit }}
                        </template>
                    </template>
                </b-table>
            </div>
        </div>
        <div>
            <b-row>
                <b-col>
                    <div class="mt-1">
                        <span class="pagination-indicator">{{ transactionHistoryPagination.startList }}-{{ transactionHistoryPagination.endList }} of {{ transactionHistoryPagination.maxPage }} per page</span>
                        
                        <b-pagination
                            hide-goto-end-buttons
                            align="left"
                            size="md"
                            :total-rows="transactionHistoryPagination.maxPage * transactionHistory.length"
                            :limit="3"
                            :per-page="transactionHistory.length"
                            @change="paginate"
                            :value="transactionHistoryPagination.page"
                            class="custom-pagination-arrow-only mb-0 ml-2">
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";

export default {
    name: "WalletTransactionHistory",
    components: {
        Datepicker
    },
    data() {
        let self = this;
        return {
            filter: {
                keyword: null,
                field: "all",
                dateFrom: null,
                dateTo: null
            },
            fields: [
                {
                    key: "created_at",
                    sortable: true,
                    label: "Date & Time"
                },
                {
                    key: "customer_name",
                    sortable: true,
                    label: "Customer"
                },
                {
                    key: "wallet_uuid",
                    sortable: true,
                    label: "Wallet",
                    formatter: (value, key, item) => {
                        return item.merchant_wallet !== null ? item.merchant_wallet.name : "";
                    }
                },
                {
                    key: "reference_no",
                    sortable: true,
                    label: "Transaction ID"
                },
                {
                    key: "type",
                    sortable: true,
                    label: "Transaction Type"
                },
                {
                    key: "debit",
                    sortable: true,
                    label: "Transaction Amount"
                },
                {
                    key: "reward_name_redeemed",
                    sortable: true,
                    label: "Reward Redeemed"
                },
                {
                    key: "voucher_name_redeemed",
                    sortable: true,
                    label: "Voucher Redeemed"
                },
                {
                    key: "brand_name",
                    sortable: true,
                    label: "Brand"
                },
                {
                    key: "branch_name",
                    sortable: true,
                    label: "Branch"
                },
                {
                    key: "employee_name",
                    sortable: true,
                    label: "Employee Name"
                },
                {
                    key: "employee_uuid",
                    sortable: true,
                    label: "Employee ID"
                }
            ],
            searchFields: [
                {
                    key: "all",
                    label: "All"
                },
                {
                    key: "customer_name",
                    label: "Customer Name"
                },
                {
                    key: "reference_no",
                    label: "Transaction ID"
                },
                {
                    key: "type",
                    label: "Transaction Type"
                },
                {
                    key: "brand_name",
                    label: "Brand"
                },
                {
                    key: "branch_name",
                    label: "Branch Name"
                }
            ],
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"],
                onChange: function(selectedDates) {
                    let filterDate = selectedDates;
                    self.filter.dateFrom = self
                        .$moment(filterDate[0])
                        .format("YYYY-MM-DD");
                    self.filter.dateTo = self
                        .$moment(filterDate[1])
                        .format("YYYY-MM-DD");
                }
            },
            searchString: "",
            selectedSearchOption: "all",
            emptyText: "No Records Found",
            isSearchType: false
        };
    },
    created: function() {
        this.$store.dispatch("wallet/getTransactionHistoryFirstPage");
    },
    methods: {
        formatDate: function(date) {
            return this.$moment(date).format("LL, LT"); // LL, LT
        },
        paginate(page) {
            this.$store.commit("wallet/setTransactionHistoryPage", page);
            this.$store.dispatch("wallet/getTransactionHistory");
        },
        async getTransactionHistory(page) {
            let param = {
                page: page,
                payload: this.searchPayload
            };
            await this.$store.dispatch("wallet/getTransactionHistory", param);
        },
        search(newSearch = false, page) {
            this.$store.commit("wallet/setSearchDefault");
            this.$store.commit("wallet/setSearchFilter", this.filter);

            if (this.filter.keyword.trim() === "") {
                return this.$store.dispatch(
                    "wallet/getTransactionHistoryFirstPage"
                );
            }

            if (newSearch) {
                this.emptyText = "Searching...";
                this.isSearchType = true;
            }

            let _this = this;
            this.$store
                .dispatch("wallet/getTransactionHistoryFirstPage")
                .then(() => {
                    _this.emptyText =
                        'No Records Found for "' + _this.filter.keyword + '"';
                    _this.isSearchType = false;
                });
            // this.$store.dispatch("rewards/search", param).then(() => {
            //     _this.emptyText =
            //         'No Records Found for "' + _this.searchString + '"';
            //     _this.isSearchType = false;
            // });
        },
        searchOption(value) {
            this.filter.field = value;
            if (this.filter.keyword.trim() !== "") {
                this.search(true);
            }
        }
    },
    watch: {
        filterKeyword() {
            this.$store.commit("wallet/setSearchDefault");
            this.$store.commit("wallet/setSearchFilter", this.filter);
            this.$store.dispatch("wallet/getTransactionHistoryFirstPage");
        },
        filterField() {
            this.$store.commit("wallet/setSearchDefault");
            this.$store.commit("wallet/setSearchFilter", this.filter);
            this.$store.dispatch("wallet/getTransactionHistoryFirstPage");
        },
        filterDateTo() {
            this.$store.commit("wallet/setSearchDefault");
            this.$store.commit("wallet/setSearchFilter", this.filter);
            this.$store.dispatch("wallet/getTransactionHistoryFirstPage");
        }
    },
    computed: {
        ...mapState("wallet", [
            "loading",
            "errors",
            "transactionHistory",
            "transactionHistoryPagination"
        ]),
        filterDateFrom() {
            return this.filter.dateFrom;
        },
        filterDateTo() {
            return this.filter.dateTo;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
